import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useVideos } from "@/hooks/content";
import { useTranslatedList } from "@/hooks/useTranslatedList";

export default function LatestVideosSection() {
  const { t } = useTranslation();
  const { items: allVideos } = useVideos();
  const latestVideos = useTranslatedList(allVideos, ["title", "description", "category"]).slice(0, 4);

  return (
    <section className="bg-white py-12 md:py-16">
      <div className="ltv-container">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-8">
          <h2 className="ltv-section-title mb-0">{t("home.latestVideos")}</h2>
          <Link
            to="/videos"
            className="inline-flex items-center gap-1 text-sm font-semibold text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            {t("home.viewAllVideos")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/videos/${video.slug}`}
              className="ltv-card group"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-accent-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="bg-black/70 text-white text-xs font-medium px-1.5 py-0.5 rounded">
                    {video.duration}
                  </span>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="bg-primary-500 text-white text-xs font-semibold px-2 py-0.5 rounded">
                    {video.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{video.publishedAt}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}